import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import leftPad from 'left-pad';
import { __n } from 'i18n-for-browser';

import apiCall from '../apiCall';

class GameDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      studentCount: 0,
      schoolClassCount: 0,
    }
  }

  static propTypes = {
    color: PropTypes.string
  };

  componentWillReceiveProps(nextProps, nextContext) {
    if (this.props.project.id !== nextProps.project.id) {
      this.fetchData(nextProps.project.id);
    }
  }

  async componentWillMount() {
    this.fetchData(this.props.project.id);
  }

  fetchData = async (projectId) => {
    const { count: studentCount } = await apiCall(`/project/${projectId}/countStudents`);
    const { count: schoolClassCount } = await apiCall(`/project/${projectId}/countSchoolClasses`);
    this.setState({
      studentCount,
      schoolClassCount,
    });
  };

  render() {
    const { project } = this.props;
    const { schoolClassCount, studentCount } = this.state;

    const inputFromDate = project.dateStart ? project.dateStart : 0;
    const inputToDate = project.dateEnd ? project.dateEnd : 0;

    const fromDate = new Date(inputFromDate);
    const fromDatesString = `${leftPad(fromDate.getDate(), 2, 0)}.${leftPad(fromDate.getMonth() + 1, 2, 0)}.${fromDate.getFullYear()}`;
    const toDate = new Date(inputToDate);
    const toDateString = `${leftPad(toDate.getDate(), 2, 0)}.${leftPad(toDate.getMonth() + 1, 2, 0)}.${toDate.getFullYear()}`;

    return (
      <div className={`gameDetails ${this.props.color}`}>
        <div className='dates'>{fromDatesString} - {toDateString}</div>
        <div className='numbers'>{schoolClassCount} {__n('sim_klas', (schoolClassCount > 1 ? 2 : 1))} | {studentCount} {__n('sim_leerling', (studentCount > 1 ? 2 : 1))}</div>
      </div>
    );
  }
}

export default connect(state => ({
  project: state.project,
}))(GameDetails);



// WEBPACK FOOTER //
// ./src/components/elements/GameDetails.js